/**
 * Given a target value and an array of numbers, finds the index of the closest element to the target
 * @param target
 * @param arr
 * @returns {number} The index of the closest element
 */
export function findClosestIndex(target: number, arr: number[]) {
  let closestIndex;
  let closestDistance = 1000000;
  for (let i = 0; i < arr.length; i++) {
    if (Math.abs(target - arr[i]) < closestDistance) {
      closestDistance = Math.abs(target - arr[i]);
      closestIndex = i;
    }
  }
  return closestIndex;
}

/**
 * Given a value, will move it from one range into another range.
 * @param num       The input value
 * @param inMin    The input value's start range's min
 * @param inMax    The input value's start range's max
 * @param outMin   The desired range's min
 * @param outMax   The desired range's min
 * @returns {*}     The scaled value
 */
export function scale(num: number, inMin: number, inMax: number, outMin: number, outMax: number) {
  return (num - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}

